export default __webpack_public_path__ + "static/media/pitching.f883fb44.svg";